import { Grid, Tab, Tabs } from "@mui/material";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { MDBox } from "../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { ScorecardAtom } from "../../../State/Scorecard.Atom";
import { DashboardPage } from "./DashboardReporting/DashboardReportingTable";
import { EEReportingBase } from "./EEAReporting/EEReportingBase";

export const ReportBase = () => {
    const scorecard = useRecoilValue(ScorecardAtom);
    const baseRoute = "/ee/scorecard/" + scorecard.scorecardId + "/reporting";

    const routes = [
        baseRoute + "/EEA",
        baseRoute + "/DashboardReports"
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path || routes[0];

    return (
        <>
            <MDBox style={{ padding: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                    Reporting
                </MDTypography>
            </MDBox>

            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="EEA Reports" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Dashboard Reports" value={routes[1]} to={routes[1]} component={Link} />
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={3}>
                    <Switch>
                        <Route path={routes[0]}>
                            <EEReportingBase />
                        </Route>
                        <Route path={routes[1]}>
                            <DashboardPage />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}